module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaBAMAAABbZFH9AAAAKlBMVEX1piP1piT1qCj2rzj3vFv3vVz4vFv5zID60o/97dL979f++fD//fv///93aZctAAAAeklEQVQY02O4CwQrnJVMukAMBiCeygACkRDecQEwj7EGxLudwAABbHuBvGMMMJAD5BXAeex3GW4KwHmMcxmuMiBALMMCJB4XQwMSj4PBAYnHwmCAxGNmUEDiMaHxUFWimoJqA6rtqC5DdTWqj9B8ixoSqKGEFoJIoQsABblB4cDTFwgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layout.png
// module id = 32
// module chunks = 1 2 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 23 24 25 27